import React from 'react';
import DocContent from './DocContent';
import { blocks } from '../content/PortalTourContent';

export default function PortalTour() {
  return <DocContent blocks={blocks} />;
}
